$(document).ready(function () {
    //var searchTerm = document.getElementById("searchInput").value;
    // Make sure inputs are empty when refreshing the page.
    //$('#categorySelect').val('');
    $('#searchInput').val('');
    var currentPage = 1;
    loadBlogPosts(currentPage);

    function loadBlogPosts(page, category = "", search) {
        $.ajax({
            url: '/umbraco/surface/BlogSurface/GetBlogPosts',
            type: 'GET',
            data: { page: page, category: category, search: search },
            success: function (data) {
                $('#blog-container').html(data);
            },
            error: function (error) {
                console.error("Error loading blog posts:", error);
                $('#blog-container').html("<p>Error loading blog posts.</p>");
            }
        });
    }

    // Pagination
    $(document).on('click', '.page-link', function (e) {
        e.preventDefault();
        let url = new URL($(this).attr('href'), window.location.origin);
        let page = url.searchParams.get("page");
        let category = ""; //url.searchParams.get("category");
        let search = url.searchParams.get("search");
        loadBlogPosts(page, category, search);
    });

    //Search
    $('.search-icon').on('click', () => {
        const searchTerm = $('#searchInput').val();
        const categoryTerm = ""; // $('#categorySelect').val();
        if (searchTerm) {
            $('.blog-home.latest-posts .search-box .close-icon').css("visibility", "visible");
        }
        loadBlogPosts(currentPage, categoryTerm, searchTerm);
    });

    $("#searchInput").keypress(function (event) {
        if (event.key === "Enter") {
            const searchTerm = $('#searchInput').val();
            const categoryTerm = ""; //$('#categorySelect').val();
            if (searchTerm) {
                $('.blog-home.latest-posts .search-box .close-icon').css("visibility", "visible");
                $('#searchButton').text(searchTerm + ' ').append('<span class="close-icon"><img class="search-close" alt="Close icon" src="/dist/images/xmark-solid.svg" /></span>').show();
                $('#clearFiltersButton').show();
                var currentPage = 1;
                loadBlogPosts(currentPage, categoryTerm, searchTerm);
            }
        }
    });

    $('.search-container .search-icon').on('click', function () {
        const searchTerm = $('#searchInput').val();
        //const categoryTerm = $('#categorySelect').val();
        if (searchTerm) {
            $('#searchButton').text(searchTerm + ' ').append('<span class="close-icon"><img class="search-close" alt="Close icon" src="/dist/images/xmark-solid.svg" /></span>').show();
            $('#clearFiltersButton').show();
            var currentPage = 1;
            loadBlogPosts(currentPage, categoryTerm, searchTerm);
        }
    });

    $('.search-container .close-icon').on('click', function () {
        $('#searchInput').val('');
        $('.blog-home.latest-posts .search-box .close-icon').css("visibility", "hidden");
    });

    // Search box hover and focus.
    const searchBox = $('.search-box');
    const searchInput = $('searchInput');

    searchInput.on('focus', () => {
        searchBox.style.borderColor = '#2365FA'; // Blue border
    });

    searchInput.on('blur', () => {
        searchBox.style.borderColor = '#A5A8AB'; // Back to default color
    });
    searchBox.on('mouseover', () => {
        if (document.activeElement !== searchInput) { // Check if input is NOT focused
            searchBox.style.borderColor = '#2365FA';
        }
    });
    searchBox.on('mouseout', () => {
        if (document.activeElement !== searchInput) { // Check if input is NOT focused
            searchBox.style.borderColor = '#A5A8AB';  // Back to default, only if not focused
        }
    });

    // Category
    $('#categorySelect').on('change', function () {
        var categoryTerm = $(this).val();
        var searchTerm = $('#searchInput').val();
        if (categoryTerm) {
            $('#categoryButton').text(categoryTerm + ' ').append('<span class="close-icon"><img class="search-close" alt="Close icon" src="/dist/images/xmark-solid.svg" /></span>').show();
            $('#clearFiltersButton').show();
            // Get results
            loadBlogPosts(currentPage, categoryTerm, searchTerm);
        } else {
            $('#categoryButton').hide();
            if (categoryTerm == '') {
                $('#clearFiltersButton').hide();
            }
        }
        loadBlogPosts(currentPage, categoryTerm, searchTerm);
    });

    // Event delegation for dynamically added elements (close-icon).
    // needed if category buttons are there so click x to close, instead of entire button.
    //$(document).on('click', '.filter-button .close-icon', function () {
    //    $(this).parent().hide();
    //    if ($(this).parent().attr('id') === 'searchButton') {
    //        $('#searchInput').val('');
    //        $('#clearFiltersButton').hide();
    //        // If categoryTerm not populated, remove Clear Filters
    //        /*if ($('#categorySelect').val() == '') {
    //            $('#clearFiltersButton').hide();
    //        }*/
    //    } /*else if ($(this).parent().attr('id') === 'categoryButton') {
    //            $('#categorySelect').val('');
    //            // If searchTerm not populated, remove Clear Filters
    //            if ($('#searchInput').val() == '') {
    //                $('#clearFiltersButton').hide();
    //            }
    //            }*/
    //    loadBlogPosts(currentPage, $('#categorySelect').val(), $('#searchInput').val());
    //});
        $('#searchButton').on('click', function () {
            $('#searchButton').hide();
            //$('#categoryButton').hide();
            $('#searchInput').val('');
            //$('#categorySelect').val('');
            $('#clearFiltersButton').hide();
            $('.blog-home.latest-posts .search-box .close-icon').css("visibility", "hidden");
            loadBlogPosts(currentPage);
        });

    $('#clearFiltersButton').on('click', function () {
        $('#searchButton').hide();
        //$('#categoryButton').hide();
        $('#searchInput').val('');
        //$('#categorySelect').val(''); 
        $('#clearFiltersButton').hide();
        $('.blog-home.latest-posts .search-box .close-icon').css("visibility", "hidden");
        loadBlogPosts(currentPage);
    });
});
